import styled from 'styled-components';
import { black, borderDialog, teamNameDialog, vsColor } from 'styles/Colors';

export const Text = styled.div`
  opacity: 0.59;
  font-family: Lato;
  font-size: 15px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.07;
  letter-spacing: 0.5px;
  color: ${black};
`;

export const ScheduledInfo = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 60px;

  svg {
    margin-right: 10px;
  }
`;

export const Teams = styled.div`
  text-align: center;
  min-height: 145px;
  width: 437px;
  border: 1px solid ${borderDialog};
  padding: 18px 0px 22px 0px;
  border-radius: 5px;
  position: relative;
  margin: 45px auto 0 auto;
`;

export const Team = styled.div`
  font-family: Oswald;
  font-size: 25px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: ${teamNameDialog};
  text-transform: uppercase;
`;

export const Versus = styled.div`
  font-size: 18.2px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: ${vsColor};
`;
